"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_TRAIT_IDS = exports.AITraitsBehavior = void 0;
exports.AITraitsBehavior = "Klei.AI.Traits";
exports.AI_TRAIT_IDS = [
    "None",
    "Stinky",
    "Ellie",
    "Joshua",
    "Liam",
    "CantResearch",
    "CantBuild",
    "CantCook",
    "CantDig",
    "Hemophobia",
    "ScaredyCat",
    "Allergies",
    "MouthBreather",
    "CalorieBurner",
    "SmallBladder",
    "Anemic",
    "SlowLearner",
    "NoodleArms",
    "InteriorDecorator",
    "SimpleTastes",
    "Foodie",
    "Regeneration",
    "DeeperDiversLungs",
    "SunnyDisposition",
    "RockCrusher",
    "Uncultured",
    "Archaeologist",
    "WeakImmuneSystem",
    "IrritableBowel",
    "Flatulence",
    "Snorer",
    "Narcolepsy",
    "Twinkletoes",
    "Greasemonkey",
    "MoleHands",
    "FastLearner",
    "DiversLung",
    "StrongArm",
    "IronGut",
    "StrongImmuneSystem",
    "BedsideManner",
    "Aggressive",
    "UglyCrier",
    "BingeEater",
    "StressVomiter",
    "BalloonArtist",
    "SparkleStreaker",
    "StickerBomber",
    "SuperProductive",
    "EarlyBird",
    "NightOwl",
    "Claustrophobic",
    "PrefersWarmer",
    "PrefersColder",
    "SensitiveFeet",
    "Fashionable",
    "Climacophobic",
    "SolitarySleeper",
    "Workaholic"
];
//# sourceMappingURL=ai-traits.js.map